module.exports = __webpack_public_path__ + "static/media/SliderAN.b0d7153f.png";